import React, { useEffect, useState } from 'react'
import { get } from 'lodash'
import { useHistory }  from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AdminCommonListLayout from './AdminCommonListLayout'
import { adminAlbumsList } from '../actions/admin_albums'
import { makeStyles, TextField, InputAdornment } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'

const useStyles = makeStyles((theme) => ({
  album_image: {
      maxWidth: '120px',
  },
  searchBox: {
    minWidth: '300px',
  }
}))

export const AdminAlbums = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()
  const is_loading = useSelector(() => adminAlbumsList.isLoading())
  const [searchText, setSearchText] = useState('')

  const columns = [
    {
      field: 'db_id',
      title: 'ID',
    },
    {
      field: 'name',
      title: 'Album Name',
    },
    {
      field: 'gallery_event_name',
      title: 'Event',
    },
    {
      field:  'edit',
      title:  'Edit',
      render: (item) =>
        <div>
          <button
            onClick={() => onEditAlbum(get(item, 'id'))}>
            Edit
          </button>
        </div>
    },
  ]

  useEffect(() => {
    async function fetchStaticObjects() {
      dispatch(adminAlbumsList.fetchListIfNeeded())
    }
    fetchStaticObjects()
  }, [])

  const onAddAlbum = () => {
    history.push('/admin/album/')
  }

  const onEditAlbum = (album_id) => {
    history.push(`/admin/album/${ album_id }`)
  }

  const handleSearchChange = (event) => {
    const value = event.target.value
    setSearchText(value)
    dispatch(adminAlbumsList.updateListFilter({ any_field: value }))
    dispatch(adminAlbumsList.fetchListIfNeeded())
  }

  const renderSearchBox = () => {
    return (
      <TextField
        className={classes.searchBox}
        placeholder="Search albums or events..."
        value={searchText}
        onChange={handleSearchChange}
        variant="outlined"
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    )
  }

    return (
      <AdminCommonListLayout
        active_key='albums'
        breadcrumbs={[
          { name: 'admin_home' },
          {
            name: 'albums',
            label: 'Albums',
            url: '/admin/albums',
          },
        ]}
        add_label='Add album'
        columns={ columns }
        is_loading={ is_loading }
        onAddRow={ onAddAlbum }
        item_list={ adminAlbumsList }
        renderAdditionalActions={ renderSearchBox }
      />
    )
}
